// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__GZmlf","title":"InfoRow_title__3GMiQ"};